export interface Countdown {
  /** Milliseconds left, never negative. */
  remainingMs: number;
  expired: boolean;
  /** Less than two minutes left — the UI warns. */
  urgent: boolean;
  /** 0..1 share of the window still left, for a progress ring. */
  fraction: number;
  /** "14:59", or "1:02:03" past an hour. */
  label: string;
}

export const URGENT_MS = 2 * 60 * 1000;

export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const ss = String(s).padStart(2, "0");
  if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${ss}`;
  return `${m}:${ss}`;
}

export function computeCountdown(createdAt: string, expiresAt: string, nowMs: number): Countdown {
  const start = Date.parse(createdAt);
  const end = Date.parse(expiresAt);
  const remainingMs = Math.max(0, end - nowMs);
  const window = Math.max(1, end - start);
  return {
    remainingMs,
    expired: remainingMs === 0,
    urgent: remainingMs > 0 && remainingMs <= URGENT_MS,
    fraction: Math.min(1, Math.max(0, remainingMs / window)),
    label: formatDuration(remainingMs),
  };
}
